<template>
  <div class="categories">
    <formCategories ref="form" @success="getList"/>
      <BasicTable
      hiddenFooter
      border
      hasOperate
      customClass="table"
      :tableData="tableData"
      :treeProps="{ children: 'sub', hasChildren: 'hasChildren' }"
      :columns="columns" >
      <template slot="tableOpeate">
        分类列表&emsp;
        <AppButton size="small" type="primary" plain @click="addCategories"><i class="fa fa-plus fa-lg icon" ></i>新增</AppButton>&emsp;
      </template>
      <template v-slot:is_hot="{ item }">
        <CheckBox :value="!!item.is_hot" :asyncClick="changeStatus(item, 'hot')"/>
      </template>
      <template v-slot:is_show="{ item }">
        <CheckBox :value="!!item.is_show" :asyncClick="changeStatus(item, 'show')"/>
      </template>
      <template v-slot:operate="{ item }">
        <AppButton size="small" type="primary" plain @click="edit(item)">编辑</AppButton>
        <AppButton size="small" type="primary" plain @click="deleteItem(item)">删除</AppButton>
      </template>
      </BasicTable>
  </div>
</template>

<script>
import { GoodsService } from '../../service/goods.service';
import { CategoriesService } from '../../service/categories.service';
import formCategories from './formCategories.vue';
import { MessageBox } from 'element-ui';
const columns = [
  { name: '分类名称', key: 'name' },
  { name: '手机显示名称', key: 'mobile_name' },
  { name: '分类级别', key: 'level' },
  { name: '是否热门', key: 'is_hot', type: 'custom'  },
  { name: '是否显示', key: 'is_show', type: 'custom'  },
  { name: '操作', key: 'operate', type: 'custom' },
];
  export default {
    name: 'categories',
    components: { formCategories },
    data() {
      return {
        columns,
        tableData: [],
      }
    },
    created() {
      this.getList();
    },
    methods: {
      edit(data) {
        this.$refs.form.open('edit', data);
      },
      addCategories() {
        this.$refs.form.open('add')
      },
      deleteItem(data) {
        MessageBox.confirm('确定要删除这条这个品牌吗？', '删除品牌').then(async () => {
          await CategoriesService.delete(data.id);
          this.getList();
        });
      },
      async getList() {
        const data = await GoodsService.categoryList();
        this.tableData = data;
      },
      changeStatus(item, type) {
        return async () => {
          await GoodsService.categoryChangeStatus(item.id, type, item['is_'+ type] === 1 ? 0 : 1);
          await this.getList();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>